import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

/** Tiempo entre cambios automáticos (la primera imagen espera este mismo intervalo antes de avanzar). */
const AUTO_MS = 4000;

function StoreInicioCarousel({ items }) {
  const n = items.length;
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    setIndex(0);
  }, [n]);

  useEffect(() => {
    if (n <= 1 || paused) return undefined;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % n);
    }, AUTO_MS);
    return () => clearInterval(t);
  }, [n, paused]);

  const prev = useCallback(() => {
    setIndex((i) => (i - 1 + n) % n);
  }, [n]);

  const next = useCallback(() => {
    setIndex((i) => (i + 1) % n);
  }, [n]);

  if (n === 0) return null;

  return (
    <section
      className="store-carousel"
      aria-roledescription="carrusel"
      aria-label="Imágenes destacadas"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="store-carousel__viewport">
        <div
          className="store-carousel__track"
          style={{ transform: `translate3d(-${index * 100}%, 0, 0)` }}
        >
          {items.map((it, i) => (
            <div key={it.id} className="store-carousel__slide">
              <div className="store-carousel__slide-inner">
                <img
                  src={it.src}
                  alt={it.alt || "Imagen del carrusel"}
                  loading={i === 0 ? "eager" : "lazy"}
                />
                {it.href ? (
                  <div className="store-carousel__cta">
                    {it.externo ? (
                      <a
                        href={it.href}
                        className="store-carousel__btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver producto
                      </a>
                    ) : (
                      <Link to={it.href} className="store-carousel__btn">
                        Ver producto
                      </Link>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>

      {n > 1 && (
        <>
          <button
            type="button"
            className="store-carousel__nav store-carousel__nav--prev"
            aria-label="Imagen anterior"
            onClick={prev}
          >
            <span aria-hidden>‹</span>
          </button>
          <button
            type="button"
            className="store-carousel__nav store-carousel__nav--next"
            aria-label="Imagen siguiente"
            onClick={next}
          >
            <span aria-hidden>›</span>
          </button>
          <div className="store-carousel__dots" role="tablist" aria-label="Seleccionar imagen">
            {items.map((it, i) => (
              <button
                key={it.id}
                type="button"
                role="tab"
                aria-selected={i === index}
                aria-label={`Imagen ${i + 1} de ${n}`}
                className={`store-carousel__dot ${i === index ? "store-carousel__dot--active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default StoreInicioCarousel;
